import { useMemo, useState } from "react";
import { Search, UserPlus, Check } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { vals } from "@/lib/format";
import CustomerFormDialog from "@/components/customers/CustomerFormDialog";
import KeyboardButton from "@/components/tpv/OnScreenKeyboard";

export default function CustomerPicker({ value, onChange }) {
  const { view, t, money } = useApp();
  const [q, setQ] = useState("");
  const [adding, setAdding] = useState(false);
  const list = useMemo(() => {
    const s = q.toLowerCase();
    return vals(view.customers)
      .filter((c) => `${c.name} ${c.family || ""} ${c.phone || ""}`.toLowerCase().includes(s))
      .sort((a, b) => (b.last_purchase_at || "").localeCompare(a.last_purchase_at || ""))
      .slice(0, 6);
  }, [view.customers, q]);

  return (
    <div className="space-y-2" data-testid="customer-picker">
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Search className="absolute top-1/2 -translate-y-1/2 start-3 w-4 h-4 text-muted-foreground" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder={t("search_customers")} data-testid="customer-picker-search"
            className="w-full h-12 rounded-xl border border-border bg-white ps-9 pe-3 focus:outline-none focus:ring-2 focus:ring-primary" />
        </div>
        <KeyboardButton value={q} onChange={setQ} testid="customer-osk" />
        <button type="button" onClick={() => setAdding(true)} className="w-12 h-12 rounded-xl bg-secondary grid place-items-center" aria-label={t("add_customer")} data-testid="customer-picker-add-btn"><UserPlus className="w-5 h-5" /></button>
      </div>
      <div className="grid gap-1.5">
        {list.map((c) => (
          <button key={c.id} type="button" onClick={() => onChange(value === c.id ? null : c.id)} data-testid={`customer-picker-option-${c.id}`}
            className={`h-12 px-3 rounded-xl border flex items-center justify-between gap-2 text-start transition-colors ${value === c.id ? "border-primary bg-primary/10" : "border-border bg-white"}`}>
            <span className="flex items-center gap-2 min-w-0">
              {value === c.id && <Check className="w-4 h-4 text-primary shrink-0" />}
              <span className="font-bold truncate">{c.name}</span>
              {c.family && <span className="text-xs text-muted-foreground truncate">{c.family}</span>}
            </span>
            <span className={`text-sm font-bold shrink-0 ${c.balance > 0 ? "text-[#E67E22]" : "text-[#1F9D55]"}`}>{money(c.balance)}</span>
          </button>
        ))}
      </div>
      <CustomerFormDialog open={adding} onOpenChange={setAdding} onSaved={(c) => { onChange(c.id); setAdding(false); }} />
    </div>
  );
}
